import gql from 'graphql-tag';

export default gql`
  query getTopLevelShopGroups {
    getTopLevelMerchGroupCategories {
      id
      slug
      title
      children: childMerchGroups {
        id
        slug
        title
      }
      categoryChildren: childMerchGroupCategories {
        id
        slug
        title
        children: childMerchGroups {
          id
          slug
          title
        }
      }
    }
  }
`;

